import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=1067a047&scoped=true&"
import script from "./SimpleDialog.vue?vue&type=script&lang=ts&"
export * from "./SimpleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=1067a047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067a047",
  null
  
)

export default component.exports